window.onscroll = function () {
    var navigation = document.getElementById("navbar");
    if (window.scrollY <= 0) {
      navigation.classList.remove("scroll-nav");
    } 
    // else if (window.scrollY <= 0 && window.innerWidth <= 990) {
    //   navigation.classList.remove("scroll-nav");
    // } 
    else {
      navigation.classList.add("scroll-nav");
    }
  };